import axios from "axios";

const BASE_URL = "https://hrmsnew.prepstripe.com/api";

// Fetch all roles
export const fetchRoles = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/roles`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    console.log(response.data);
    return response.data; // Ensure the roles object is returned
  } catch (error) {
    throw error.response?.data || "Error fetching roles.";
  }
};

// Create a new role
export const createRole = async (token, data) => {
  try {
    console.log("token: ", token);
    console.log("data: ", data);
    const response = await axios.post(`${BASE_URL}/roles`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.role;
  } catch (error) {
    const errData = error.response?.data;
    throw {
      message: errData?.message || "Failed to add role.",
      fieldErrors: errData?.errors || {}, // pass full field errors
    };
  }
};

// Get details of a specific role
export const getRoleDetails = async (token, roleId) => {
  try {
    const response = await axios.get(`${BASE_URL}/role/${roleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.role;
  } catch (error) {
    throw error.response.data;
  }
};

// Update a specific role
export const updateRole = async (token, roleId, data) => {
  try {
    const response = await axios.put(`${BASE_URL}/roles/${roleId}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.role;
  } catch (error) {
    throw error.response.data;
  }
};

// Delete a specific role
export const deleteRole = async (token, roleId) => {
  try {
    const response = await axios.delete(`${BASE_URL}/roles/${roleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.message;
  } catch (error) {
    throw error.response.data.message;
  }
};
